import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./NewLabel.module.scss";

function NewLabel({ className }) {
  return <div className={classnames(styles["new-label"], className)}>NEW</div>;
}

NewLabel.defaultProps = {
  className: "",
};

NewLabel.propTypes = {
  className: PropTypes.string,
};

export default NewLabel;
